import { useTheme } from 'styled-components';

import { TransparentButton, Typography } from '@libs/components';
import { formatPrice } from '@libs/helpers';

import { useTranslation } from 'src/hooks';

import {
  CustomToolTipIcon,
  DetailsLeftComponentDescriptionsWrapper,
  DetailsLeftComponentWrapper,
  DetailsRightComponentWrapper,
  DetailsWrapper,
  PaddingWrapper,
} from './styles';

export type SelectedChartItemDetailsProps = {
  currencySymbol: string;
  averagePrice?: number;
  currentPrice?: string;
  handlePnlInfoClick?: () => void;
};

const SelectedChartItemDetails: React.FC<SelectedChartItemDetailsProps> = ({
  averagePrice,
  currencySymbol,
  currentPrice,
  handlePnlInfoClick,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const formattedAveragePrice = formatPrice(averagePrice || 0);
  const formattedPrice = formatPrice(currentPrice || 0);

  return (
    <PaddingWrapper>
      <DetailsWrapper>
        <DetailsLeftComponentWrapper>
          <TransparentButton onClick={handlePnlInfoClick}>
            <CustomToolTipIcon height={28} width={28} />
          </TransparentButton>

          <DetailsLeftComponentDescriptionsWrapper>
            <Typography
              type="caption"
              fontFamily="primaryMedium"
              color={colors.text.secondary}
            >
              {t('wallet_average_price')}
            </Typography>
            <Typography type="bodyButton" fontFamily="primaryMedium">
              {formattedAveragePrice}
              {currencySymbol}
            </Typography>
          </DetailsLeftComponentDescriptionsWrapper>
        </DetailsLeftComponentWrapper>
        <DetailsRightComponentWrapper>
          <Typography
            type="caption"
            fontFamily="primaryMedium"
            color={colors.text.secondary}
          >
            {t('wallet_current_price')}
          </Typography>
          <Typography type="bodyButton" fontFamily="primaryMedium">
            {formattedPrice}
            {currencySymbol}
          </Typography>
        </DetailsRightComponentWrapper>
      </DetailsWrapper>
    </PaddingWrapper>
  );
};

export default SelectedChartItemDetails;
